import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { TRAINING_VENUES } from '../utils/firebaseUtils';

/**
 * Venue checkboxes for filtering or coach edit selection.
 * @param {boolean} allowEmpty - if true, all venues can be unchecked (coach edit).
 *   if false (default), at least one venue must stay selected (client filter).
 */
const VenueFilterCheckboxes = ({
  selectedVenueIds,
  onChange,
  label = 'Vietos',
  allowEmpty = false
}) => {
  const toggleVenue = (venueId) => {
    if (selectedVenueIds.includes(venueId)) {
      if (!allowEmpty && selectedVenueIds.length === 1) return;
      onChange(selectedVenueIds.filter((id) => id !== venueId));
    } else {
      onChange([...selectedVenueIds, venueId]);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        gap: { xs: 0.15, sm: 0.5 },
        mb: 2,
        width: '100%',
        maxWidth: '100%'
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          mr: { xs: 0.25, sm: 0.5 },
          fontSize: { xs: '0.78rem', sm: '0.875rem' },
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}
      >
        {label}:
      </Typography>
      {TRAINING_VENUES.map((venue) => (
        <FormControlLabel
          key={venue.id}
          sx={{
            m: 0,
            flexShrink: 0,
            '& .MuiFormControlLabel-label': { lineHeight: 1.2 }
          }}
          control={
            <Checkbox
              size="small"
              checked={selectedVenueIds.includes(venue.id)}
              onChange={() => toggleVenue(venue.id)}
              sx={{
                color: venue.color,
                '&.Mui-checked': { color: venue.color },
                p: { xs: 0.4, sm: 0.75 }
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.35 }}>
              <Box
                sx={{
                  width: { xs: 8, sm: 10 },
                  height: { xs: 8, sm: 10 },
                  borderRadius: '50%',
                  bgcolor: venue.color,
                  flexShrink: 0
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: '0.78rem', sm: '0.875rem' },
                  whiteSpace: 'nowrap'
                }}
              >
                {venue.label}
              </Typography>
            </Box>
          }
        />
      ))}
    </Box>
  );
};

export default VenueFilterCheckboxes;
